import { LoadingButton } from "@mui/lab";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import { useState } from "react";
import serviceParametrizacao from "@/services/serviceParametrizacao";
import { toast } from "react-toastify";

export interface IProps {
    open: boolean;
    data: {
        id: string;
        global: boolean;
    };
    onClose: any;
    onSuccess: any;
}

export function DialogDelete({ open, data, onClose, onSuccess }: IProps) {
    const [loading, setLoading] = useState(false);

    const onSubmit = (id: string) => {
        setLoading(true);

        serviceParametrizacao
            .disable(id)
            .then((result) => {
                if (result) {
                    toast.success("Parâmetro desabilitado com sucesso!");
                    onClose();
                }
            })
            .catch((err) => {
                toast.error("Erro ao desabilitar o Parâmetro!", err);
            })
            .finally(() => {
                onSuccess();
                setLoading(false);
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            open={open}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
        >
            <DialogTitle>{"Desabilitar Parâmetro"}</DialogTitle>
            <DialogContent style={{ padding: "30px 20px" }} dividers>
                <DialogContentText>
                    <Typography>
                        {data.global
                            ? "Parâmetro Global não pode ser desabilitado."
                            : "Deseja realmente desabilitar o parâmetro selecionado?"}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                {data.global ? (
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Fechar
                    </Button>
                ) : (
                    <>
                        <Button
                            onClick={onClose}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Não
                        </Button>
                        <LoadingButton
                            loading={loading}
                            onClick={() => onSubmit(data.id)}
                            color="primary"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Sim
                        </LoadingButton>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}
